import { ServiceOrderOrdering } from '@mews-commander/data-access';
import { createHandler } from '@mews/std';
import { ProductCheckListTableColumn } from '../types';

export const serviceOrderOrderingToProductCheckListTableColumn = createHandler<
    ServiceOrderOrdering,
    ProductCheckListTableColumn
>(
    {
        [ServiceOrderOrdering.ResourceNumber]: ProductCheckListTableColumn.Resource,
        [ServiceOrderOrdering.Owner]: ProductCheckListTableColumn.Owner,
    },
    ProductCheckListTableColumn.Resource
);

export const productCheckListColumnToServiceOrderOrdering = createHandler<
    ProductCheckListTableColumn,
    ServiceOrderOrdering
>(
    {
        [ProductCheckListTableColumn.Resource]: ServiceOrderOrdering.ResourceNumber,
        [ProductCheckListTableColumn.Owner]: ServiceOrderOrdering.Owner,
    },
    ServiceOrderOrdering.ResourceNumber
);
